"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFallbackUrl;
var _isSvgUrl = _interopRequireDefault(require("./isSvgUrl"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getFallbackUrl(url, dimension, size, quality) {
  if (!(0, _isSvgUrl.default)(url)) {
    return `${url}?${dimension}=${size}&q=${quality}`;
  }
  return url;
}